import * as CommentingV2 from './CommentingV2';
import * as CommentingV3 from './CommentingV3';
export function getCommentingAPI({
  isUngatedForFASCommenting
}) {
  if (isUngatedForFASCommenting) {
    return CommentingV3;
  }
  return CommentingV2;
}